<template>
  <div class="mx-auto pa-0"  id="header-carousel">

    <v-flex>
      <component :is="isMobile ? 'CarouselPostsMobile' : 'CarouselPosts'"></component>
    </v-flex>

    <!-- Resto del contenido -->
    <v-flex class="w-100 mx-auto">
      <MyShortcuts></MyShortcuts>
    </v-flex>

    <div class="cm-container">
      <Celebrations2 />
    </div>

    <div class="w-100 mx-auto">
      <LastNews />
    </div>

    <div class="cm-container">
      <component :is="isMobile ? 'MomentSecurityMobile' : 'HomeMomentSecurity'" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from "vuex";

import MyShortcuts from "./MyShortcuts.vue";
import Celebrations2 from "./Celebrations2.vue"
import LastNews from "./LastNews.vue"
import HomeMomentSecurity from "../Posts/HomeMomentSecurity.vue"
import MomentSecurityMobile from "../Posts/MomentSecurityMobile.vue"
import CarouselPosts from "@/components/Posts/CarouselPosts.vue";
import CarouselPostsMobile from "@/components/Posts/CarouselPostsMobile.vue";

export default {
  components: {
    MyShortcuts,
    Celebrations2,
    LastNews,
    HomeMomentSecurity,
    MomentSecurityMobile,
    CarouselPosts,
    CarouselPostsMobile
  },
  data() {
    return {
      result: [],
      windowWidth: window.innerWidth, 
    };
  },
  mounted() {
    this.browser_detect();
    window.scrollTo(0, 0);
    window.addEventListener('resize', this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },
  methods: {
    browser_detect() {
      let ua = window.navigator.userAgent;
      let ms_ie = /MSIE|Trident/.test(ua);
      if (ms_ie) {
        this.result.push("ie");
      } else {
        this.result.push("otro");
      }
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
  },
  computed: {
    ...mapState("user", ["current_user"]),
    isMobile() {
      return this.windowWidth <= 960;
    },
  },

};
</script>

<style>
.cm-header {
  height: 25rem;
  min-height: 22.5rem;
  position: relative;
  display: flex;
}
  /* dots */
  .v-carousel__controls__item div {
    display: none;
  }
 div > div.v-carousel__controls > div > button {
    background-color: #919199;
    height: 8px;
    width: 8px;
    border-radius: 50%;
  }
  #header-carousel > div > div.v-carousel__controls > div > button.v-btn--active {
    width: 40px;
    height: 8px;
    border-radius: 20px;
    background-color: #fff !important;
  }
  #header-carousel .v-carousel__controls {
    bottom: 3rem;
  }
  .overlay-content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 1175px;
    padding: 0 1.25rem;
  }
  @media (min-width: 1500px) {
    .overlay-content {
      max-width: 1440px;
    }
  }
  @media (max-width: 1175px) {
    .overlay-content {
      padding: 0px 5%;
    }
  }

  .overlay-text {
    width: 50%;
  }

  .title-text {
    font-weight: 700;
    font-size: 2.25rem;
    line-height: 3.375rem;
    padding-bottom: 1.25rem;
  }

  .blue-background {
    background-color: #232272;
    overflow: hidden;
    height: 100%;
    text-align: center;
  }

  .image-background {
    background-color: #f5f5f5;
    overflow: hidden;
    height: 100%;
    min-height: 186.21px;

    &:hover {
      cursor: pointer;
    }
  }

  .header-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .btn-outlined-white {
    color: white;
    border: 0.125rem solid white;
    border-radius: 1.5625rem;
    padding: 0.625rem 1.25rem;
    transition: color .06s ease, border .06s ease;
    pointer-events: auto;

    &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
}

.cm-container {
  background-color: #F4F4FF !important;
}

@media (min-width: 960px) {
  .image-background {
    order: 1;
  }

  .blue-background {
    order: 0;
  }

  .overlay-text {
    width: 50%;
  }
}

@media (max-width: 960px) {
  .blue-background {
    order: 1;
    min-height: 200px;
  }
  .overlay-text {
    width: 100%;
    margin-bottom: 5rem;
  }

  .cm-header {
    height: auto;
    min-height: 22.5rem;
  }

  .title-text {
    font-size: 1.5rem;
    line-height: 2rem;
    padding-bottom: 0.5rem;
  }

  .overlay-content {
    top: 80%;
  }
  .image-background, .blue-background {
    height: 200px;
  }
}

.p-home {
  padding: 2.5rem 10%;
}

.home-title {
  font-weight: 400;
  font-size: 2.25rem;
}
.home-subtitle {
  font-size: 1.125rem;
  line-height: 1.5rem;
  margin: 0;
}

.content-center {
  align-content: center;
}

p {
  font-size: 1rem;
}

.cm-btn-bg-blue {
  background-color: #28385C !important;
  border: 0.125rem solid #28385C;
  color: white !important;
  border-radius: 1.5625rem;
  text-transform: none;
  font-size: 1rem;
  font-weight: 600;
  box-shadow: none !important;
}

.cm-title {
  font-weight: 600;
  font-size: 2rem !important;
  line-height: 3rem;
}
.cm-subtitle {
  font-weight: 400;
  font-size: 2rem !important;
  line-height: 3rem;
}
@media (max-width: 600px) {
  .p-home {
    padding: 1.875rem 0.3125rem;
  }
}

.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.v-card__title {
  padding: 0.625rem;
}

.position-relative {
  position: relative;
}

.cm-btn-bg-white {
  background-color: #fff !important;
  border: 0.125rem solid #28385C;
  color: #28385C !important;
  border-radius: 1.5625rem;
  text-transform: none;
  font-size: 1rem;
  font-weight: 600;
  box-shadow: none !important;
  padding: 25px;
  margin: 0

}

.cm-btn-secondary {
  color: #49494D !important;
  font-size: 1rem;
  font-weight: 600;
  border-bottom: 1px solid #49494D;
  margin-left: 1rem;
  background-color: transparent !important; /* Fondo transparente */
  box-shadow: none !important; /* Sin sombra */
  border-radius: 0; /* Sin bordes redondeados */
  text-transform: none;
}

.responsive-container {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
}
/* 
@media (max-width: 1440px) {
  .responsive-container {
    max-width: 1290px;
  }
}

@media (max-width: 1290px) {
  .responsive-container {
    max-width: 100%;
  }
} */
</style>
